<nav id="sidebar" [class.active]="isCollapsed">
  <button id="sidebarCollapse" type="button" class="btn hamburgerTransition" (click)="toggleSidebar()"
    [attr.aria-expanded]="!isCollapsed" [attr.aria-label]="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
    title="Toggle sidebar">
    <i class="fa fa-angle-left sidebar-toggle-icon" [class.isActive]="isCollapsed"></i>
  </button>
  <div class="sidebar-header">
    <img src="assets/pulte_logo.png" title="Plan Change Request" width=190>
    <h3>Plan Change Request</h3>
  </div>

  <ul class="list-unstyled components">
    <li>
      <a [routerLink]="['/my-requests']" title="My Requests"><i class="fa fa-light fa-list"></i><span
          class="nav-label">My Requests</span></a><br />
    </li>
    <li>
      <a [routerLink]="['/new-request']" title="Create a new Request"><i class="fa fa-pencil fa-fw"></i><span
          class="nav-label">Create a new Request</span></a><br />
    </li>
    <li>
      <a [routerLink]="['/all-requests']" [state]="{ clearSearch: true }" title="All Requests"><i
          class="fa fa-regular fa-list"></i><span class="nav-label">All Requests</span></a><br />
    </li>
    <li>
      <a href="https://pulte.sharepoint.com/sites/PCRDashboard" target="_blank" rel="noopener noreferrer"
        title="Help"><i class="fa fa-info-circle fa-lg"></i><span class="nav-label">Help</span></a>
    </li>
  </ul>
</nav>
